export default {
    back: 'Voltar',
    title: 'Sinastria',
    route: '/compatibilidades',
    seeSynastry: 'Ver Sinastria',
    routeSynastry: '/sinastria/{targetId}?invite=true',
    subtitle: 'Convide seus amigos para experimentar a Sinastria gratuitamente',
    homeRouteDesktop: '/area-pessoal',
    homeRouteMobile: '/app',

    affinity: {
        basicAffinity: 'Afinidades Básicas',
        basicAffinityText: 'Cada signo possui seu próprio modo de operação. <br> Nessa etapa, comparamos planetas importantes e seus posicionamentos nos signos para descobrir a afinidade básica entre eles, dando uma chance para aquela famosa pergunta: "será que o meu signo tem a ver com o seu?".',
        interpretation: 'Interpretação',
        introText: 'Uma avaliação sobre como os posicionamentos do Sol, Lua e Vênus de ambos interagem entre si.'
    },

    aspects: {
        allAspects: 'Todos Aspectos',
        allTheAspects: 'Todos os Aspectos',
        existingAspects: 'Aspectos Existentes',
        intuitionCreativity: 'Intuição e Criatividade',
        interestsValues: 'Interesses e Valores',
        communicationIntellect: 'Comunicação e Intelecto',
        familySocializing: 'Família e Convívio',
        business: 'Finanças',
        cooperationBusiness: 'Cooperação e Negócios',
        naturalAffinity: 'Afinidade Natural - <a target="_blank" rel="noopener noreferrer" href="{siteUrl}/sobre-a-sinastria.php#relacionamento">{knowMore}</a>',
        allCategories: 'Todas as categorias',
        planetaryAspects: 'Aspectos Planetários',
        planetaryAspectsText: 'Abaixo encontram-se os aspectos mais importantes encontrados na sinastria. <br> ' +
            'É claro que todos nós gostaríamos de encontrar apenas interações fluidas, <br> ' +
            'mas saiba que dessa forma o relacionamento não teria as faíscas <br> ' +
            'necessárias para se tornar desafiador e estimulante! <br> ' +
            'Muitas vezes, algumas diferenças ajudam o relacionamento a dar certo.',
        introText: 'Saiba quais são os cruzamentos relevantes e que possuem mais (ou menos) afinidade, com descrições únicas e personalizadas.',
        aspect: 'Aspecto',
        categories: 'Categorias:',
        readAll: '+ Ler tudo'
    },

    end: {
        conclusion: 'Conclusão',
        result: 'Veja resultado final da sua Sinastria.',
        report: '{actorName}, este foi o relatório da sua sinastria com {targetName}. ' +
            'As informações analisadas são válidas para qualquer tipo de relação, embora exista um pouco mais de ênfase para relacionamentos amorosos.',
        text: 'Saiba que um relacionamento é composto por muitas variáveis e a influência astrológica é apenas uma delas. ' +
            'O livre arbítrio é uma peça igualmente importante e o fator surpresa pode abrir ainda um leque de oportunidades extras na relação. ' +
            'Qualquer relacionamento entre duas pessoas pode funcionar, contanto que haja respeito, consciência, compreensão e boa vontade! ' +
            'Aconselhamos ler esta análise com a mente aberta, bom senso e intuição, não tomando nada como verdade absoluta e imutável. ' +
            'Esperamos que o entendimento da sua sinastria com {targetName} mostre os pontos de maior atenção no relacionamento e dê aquela força astral bem-vinda. ' +
            'Boa sorte!',
        seeMore: 'Ver mais Sinastrias',
    },

    energy: {
        energyComparison: 'Comparação Energética',
        text: 'Cada pessoa tem um conjunto energético formado a partir dos elementos, <br> ' +
            'qualidades e polaridades que compõem o mapa astral. <br> ' +
            'Aqui nós comparamos o conjunto de vocês para ver se existe equilíbrio na <br> ' +
            'distribuição ou se há características dominantes no relacionamento.',
        elements: 'Elementos',
        elementsText: 'O Fogo representa ação, ímpeto e criatividade. A Terra, substância, solidez e praticidade. O Ar é o aspecto mental, o intelecto e a comunicação. A Água rege as emoções, a sensibilidade e o inconsciente.',
        moreAboutElements: 'Mais sobre elementos',
        qualities: 'Qualidades',
        qualitiesText: 'Cardinal indica a predisposição por iniciar e liderar, Fixo diz respeito a continuação, manutenção e a estabilidade, enquanto Mutável é mais adaptável, transformador e confortável à mudanças.',
        moreAboutQualities: 'Mais sobre qualidades',
        polarities: 'Polaridades',
        polaritiesText: 'O símbolo da dualidade universal. Yang simboliza o lado masculino, ativo e direcionado para o exterior. Yin simboliza o lado feminino, reativo e direcionado para o interior.',
        yang: 'Yang/Ativo',
        yin: 'Yin/Reativo',
        moreAboutPolarities: 'Mais sobre polarização',
        introText: 'Cada pessoa tem um conjunto energético próprio que vai nortear sua personalidade e sua forma de se relacionar.'
    },

    introduction: {
        title: 'Introdução',
        doNotNotify: 'Não notificar {targetName}',
        howItWorks: 'Como funciona?',
        whatWillFind: '{actorName}, veja o que você vai encontrar na sinastria!',
        presentation: 'Vamos apresentar informações importantes baseadas na comparação entre os dois mapas, algo que vai te ajudar a entender melhor o seu relacionamento com as pessoas. Boa sorte!',
        relationshipAreas: 'Áreas do Relacionamento',
        relationshipAreasText: 'Amor, trabalho, comunicação, vida social... Quais áreas do relacionamento são influenciadas pelos aspectos.',
        seeAstralCompatibility: 'Compatibilidade Astral',
        astralCompatibility: 'Compatibilidade Astral',
        details: 'Ver a análise completa',
        backToAL: 'Voltar para o Astrolink',
        detailsDesktop: 'Veja todos os detalhes da sua sinastria',
    },

    astralNumber: {
        title: 'Número Astral',
        introText: 'Baseado na harmonia entre os aspectos, cada valor tem seu próprio significado e informações relevantes para o relacionamento.',
        astralNumberCombination: 'O Número Astral da combinação',
        text: 'O número astral é uma medição funcional da harmonia entre aspectos planetários encontrados ' +
            'na sinastria. Quanto maior for o número, maior será a predisposição ' +
            'harmônica que permeia o relacionamento. Um valor a ' +
            'partir de 60 pontos já pode ser considerado uma boa média!'
    },

    modal: {
        introText: 'A Sinastria é a ferramenta essencial para você compreender a <strong>Compatibilidade Astral</strong> dos seus relacionamentos, descobrindo todos os potenciais e desafios.',
        bePremium: 'Seja Premium e faça <strong>Sinastrias ilimitadas</strong>&nbsp;com mapas extras e outros perfis, além de ter&nbsp;<strong>vários outros benefícios desbloqueados!</strong> ',
        unlock: 'Desbloquear',
    },
    
    bar: {
        bePremium: 'Seja Premium, faça <strong>Sinastrias ilimitadas com&nbsp; Mapas Extras</strong> e muito mais!',
        unlock: 'Desbloquear'
    },

    swipe: {
        imageTitle: 'title',
        imageStepOne: 'step-one',
        imageStepTwo: 'step-two',
        imageStepThree: 'step-three',
        unlockNow: 'Desbloquear agora!',
        introText: 'O recurso de Compatibilidade Astral (Sinastria) do Astrolink pode ser utilizado com perfis que constam em sua lista de amigos, com outros usuários do site ou com algum mapa astral cadastrado por você na área de mapas extras',
        
        frustration: {
            title: 'Opa, sentimos muito!',
            playStore: 'Baixar pela Play Store',
            appleStore: 'Baixar pela Apple Store',
            imgAlt: 'Homem fazendo manutenção na lua', 
            playLink: 'https://play.google.com/store/apps/details?id=com.astrolink.webapp',
            textOne: '<strong>{username}</strong>, infelizmente nossa assinatura está temporariamente indisponível em nosso site, mas você pode fazer isso no <strong>Aplicativo Astrolink</strong>!',
            textTwo: '<strong>Baixe nosso aplicativo no botão abaixo</strong>. Não se preocupe, se você se inscrever pelo aplicativo também poderá acessar a versão completa no site.'
        }
    },

    frustationButton: {
        route: 'assinar?ref=b6b10f76fe91042bb325b0dff40984c8',
        label: '<span>Recurso Exclusivo</span><span>Desbloquear</span>'
    },

    invite: {
        route: '/sinastria/generate-invitation',
        buttonEnd: 'Gerar meu convite',
        astralNumber: 'Seja Premium para desbloquear',
        description: 'Envie seu link e convide seus amigos para experimentarem a Compatibilidade Astral.',

        view: {
            route: '/',
            return: 'voltar',
            buttonCopied: 'Link copiado!',
            title: 'Compatibilidade Astral',
            buttonShare: 'Enviar pelo Whatsapp',
            buttonCopy: 'Copiar link do convite',
            discover: '{name}, quem tem mais harmonia com você?',
            description: 'Envie seu link e convide seus amigos para experimentarem a Compatibilidade Astral.',
            wasInvited: '<strong>{name}</strong> te convidou para ver a compatibilidade astrológica entre vocês.',

            share: {
                title: 'Descubra como é sua compatibilidade astral com {name}',
                description: 'Com a sinastria do Astrolink você entende tudo sobre a relação de vocês!'
            },
            
            footer: {
                allDirects: 'Sinastria Astrolink v.2.1 © 2017 - {crrYear} Todos os direitos reservados',
                dowloadApp: '<strong>Baixe nosso app</strong> e veja seu Horóscopo personalizado, Mapa Astral completo e muito mais!',
                stores: {
                    playStore: 'Baixe na Play Store',
                    appleStore: 'Baixe na Apple Store',
                    playLink: 'https://play.google.com/store/apps/details?id=com.astrolink.webapp',
                    playUrlImage: 'footer/cta-google-play.png',
                    appleLink: 'https://apps.apple.com/br/app/astrolink/id1598327566',
                    appleUrlImage: 'footer/cta-apple-store.png',
                }
            }
        },

        authFunctional: {
            titles: {
                login: 'Já possui perfil?',
                personalData: 'Complete seu cadastro para poder acessar o <strong>Astrolink</strong> quando quiser',
                birthData: 'Usaremos seus dados de nascimento para comparar os posicionamentos astrológicos',
            },

            buttons: {
                birthData: 'Continuar',
                personalData: 'Ver nossa Compatibilidade',
            },
        },
    },

    banner: {
        desk: {
            link: 'Não quero',
            button: 'CONVIDAR MEUS AMIGOS PARA EXPERIMENTAR <strong> GRATUITO </strong>',
            paragraph: 'Você pode convidar qualquer pessoa a <strong> conhecer a Sinastria </strong> entre vocês, os detalhes dos aspectos harmônicos <strong> e muito mais </strong>!',
        },

        app: {
            ghostButton: 'CONVIDAR MEUS AMIGOS PARA EXPERIMENTAR GRATUITAMENTE',

            subscriber: {
                button: 'CRIAR SINASTRIAS',
                paragraph: 'Você pode convidar qualquer pessoa para conhecer a sinastria entre vocês, os detalhes dos aspectos harmônicos e muito mais!'
            },

            nonSubscriber: {
                button: 'FAZER MINHA SINASTRIA DE GRAÇA',
                paragraph: 'Você pode convidar qualquer pessoa para aprender um pouco sobre a sinastria!'
            }
        }
    },

    preview: {
        invite: 'CONVIDAR',
        toView: 'Visualizar',
        seeAll: 'Ver todos >',
        newSynastry: 'Sinastria',
        genInvite: 'Gerar meu convite',
        inviteFriends: 'Convide seus amigos',
        lastInvite: 'Última recebida pelo link',
    }
};